import styled from 'styled-components';

export const Card = styled.div`
    width: 360px;
    min-height: 160px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${props => props.bgColor ? props.bgColor : '#1a1a1a'};
    color: #fff;
    padding: 20px;
    margin: 1.5em;
    border: ${props => props.border === 'none' ? 'none' : '1px solid var(--green)'}
    text-align: center;

    h2.ass-heading {
        text-align: center;
        text-transform: uppercase;
        font: bold italic 22px 'Roboto Condensed';

    }

    button {width: 200px; height: 36px;}


`

export const FixedCard = styled.div`
    position: fixed;
    bottom: 0;
    right: 0;
     display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    color: #fff;
    padding: 20px;
    margin: 1.5em;
      text-align: center;
    

       h2.ass-heading {
        text-align: center;
        text-transform: uppercase;
        font: bold italic 12px 'Roboto Condensed';

    }

    button {width: 120px; height: 28px; font-size: 14px;}
`


// WEBPACK FOOTER //
// ./src/components/Ploa2Cards/PendingAssessments.styles.ts